import { render, staticRenderFns } from "./ZoteroHint.vue?vue&type=template&id=6cb27abb&scoped=true"
import script from "./ZoteroHint.vue?vue&type=script&lang=js"
export * from "./ZoteroHint.vue?vue&type=script&lang=js"
import style0 from "./ZoteroHint.vue?vue&type=style&index=0&id=6cb27abb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb27abb",
  null
  
)

export default component.exports